module.exports = __webpack_public_path__ + "img/SketchPng87907a4b551f1c90d20b972554c176f173ddc55e07fbe78e285742904eb2592e.10399e1f.png";